import { useLocation, useNavigate } from 'react-router-dom';
import PaystubPreview from 'components/paystub/paystub-preview';
import WithSideBarAndNavBar from 'layouts/withSideBarAndNavBar/withSideBarAndNavBar';
import Button from 'common/button/button';
import { useState } from 'react';

const PaystubOwnerPreview = () => {
  const { search } = useLocation();
  const searchParams = new URLSearchParams(search);
  const id = searchParams.get('id');
  const navigate = useNavigate();
  const [pdfUrl, setPdfUrl] = useState<string>('');
  const handleDownloadPDF = async () => {
    window.location.href = pdfUrl;
  };

  return (
    <div>
      <WithSideBarAndNavBar>
        <div className="flex w-full justify-center">
          <div className="w-full max-w-[540px]">
            <div className="mb-10 flex w-full justify-between">
              <div className="w-[170px]">
                <Button label="되돌아가기" type="type16" height={38} action={() => navigate(-1)} />
              </div>
              <div className="w-[170px]">
                <Button label="다운로드" type="type2" height={38} action={handleDownloadPDF} />
              </div>
            </div>
            <div>
              <PaystubPreview id={id ?? ''} setPdfUrl={setPdfUrl} />
            </div>
          </div>
        </div>
      </WithSideBarAndNavBar>
    </div>
  );
};

export default PaystubOwnerPreview;
